export { IndustryRate } from './IndustryRate';
